module.exports = __webpack_public_path__ + "static/img/fangan_title.3d1a4a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/fangan_title.png
// module id = MHBo
// module chunks = 0